import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { PHONE_FORMAT } from '@app/member-response-portal/model/constants';
import { PolicyHolderDto } from '@app/member-response-portal/model/policyHolderDto';
import { PolicyMemberDto } from '@app/member-response-portal/model/policyMemberDto';
import { SurveyOtherHealthInsuranceHelper } from '@app/member-response-portal/shared/survey-other-health-insurance-helper';

@Component({
  selector: 'app-other-health-insurance-view',
  templateUrl: './other-health-insurance-view.component.html',
  styleUrls: ['./other-health-insurance-view.component.scss'],
})
export class OtherHealthInsuranceViewComponent implements OnInit {
  //#region Public Variables
  private _policyHolder!: PolicyHolderDto;

  @Input() public Index! : number;
  @Input() public set PolicyHolder(value: PolicyHolderDto) {
    this._policyHolder = value;
    if (this.Form) {
      this.patchFormData(value);
    } else {
      this.initializeForm();
    }
  }

  public get PolicyHolder(): PolicyHolderDto {
    return this._policyHolder;
  }

  public Form!: FormGroup;
  public PhoneFormat: string = PHONE_FORMAT;
  //#endregion Public Variables

  public get PolicyMembers(): FormArray {
    return this.Form?.get('PolicyMembers') as FormArray;
  }

  public ngOnInit(): void {
    if (!this.Form) {
      this.initializeForm();
    }
    this.loadData(this.PolicyHolder);
  }

  private loadData(policyHolderDto: PolicyHolderDto): void {
    if (policyHolderDto) {
      this.patchFormData(policyHolderDto);
    }
  }

  private initializeForm(): void {
    this.Form = SurveyOtherHealthInsuranceHelper.CreatePolicyHolderSummaryFormGroup();
  }

  private patchFormData(policyHolderDto: PolicyHolderDto): void {
    this.Form.patchValue(policyHolderDto);
    if (policyHolderDto.PolicyMembers && policyHolderDto.PolicyMembers.length) {
      this.loadPolicyMembers(policyHolderDto.PolicyMembers);
    }
    this.Form.updateValueAndValidity();
  }

  private loadPolicyMembers(policyMembers: PolicyMemberDto[]): void {
    this.PolicyMembers.clear();
    policyMembers.forEach((member: PolicyMemberDto) => {
      this.PolicyMembers.push(
        SurveyOtherHealthInsuranceHelper.CreatePolicyMemberFormGroup(member)
      );
    });
    this.PolicyMembers.disable();
    this.PolicyMembers.updateValueAndValidity();
  }
}
